import { render } from "./Group.vue?vue&type=template&id=14af003b"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"
script.render = render

export default script